import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-dashboard-header'),_c(VRow,{attrs:{"xs12":""}},[_c(VCol,[_c('app-hacknight'),(_vm.getHacknight)?_c('app-hacknights-participants'):_vm._e()],1),_c(VCol,[_c('app-participants')],1)],1),_c(VRow,[_c(VCol,{staticClass:"d-flex justify-center"},[_c('ParticipantsChart')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }